import { render } from "./ScaleOneToTen.vue?vue&type=template&id=695d621a"
import script from "./ScaleOneToTen.vue?vue&type=script&lang=js"
export * from "./ScaleOneToTen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])